<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-01 16:27:45
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-05-25 14:05:20
 * @FilePath: \sns-user-frontend\src\components\web\drawer.vue
 * @Description: 抽屉
-->
<template>
  <div :class="className">
    <el-drawer 
      v-model="visible" 
      direction="btt"
      :with-header="false"
      :lock-scroll="true"
      :before-close="beforeClose"
      :destroy-on-close="destroyOnClose"
      :append-to-body="appendToBody"
      class="btt-drawer"
    >
      <template #default>
        <slot></slot>
      </template>
    </el-drawer>
  </div>
  
</template>

<script setup>


const emit = defineEmits(['update:modelValue', 'before-close'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  beforeClose: {
    type: Function,
    default: null
  },
  destroyOnClose: {
    type: Boolean,
    default: true
  },
  appendToBody: {
    type: Boolean,
    default: true
  },
  className: {
    type: String,
    default: ''
  }
})

const visible = ref(false)

const beforeClose = (done) => {
  if (props.beforeClose) {
    props.beforeClose(done)
  } else {
    done()
  }
}

watch(() => props.modelValue, (val) => {
  visible.value = val
})

watch(() => visible.value, (val) => {
  emit('update:modelValue', val)
})

onDeactivated(() => {
  visible.value = false
})

</script>

<style lang="postcss">
 .btt-drawer{
  --el-drawer-padding-primary: 0;
  height: calc(100vh - var(--orbit-nav-height) - var(--orbit-notice-height, 0px)) !important;
  border-radius: 20px 20px 0 0;
  .el-drawer__body {
    height: 100%;
    margin: 48px 0 0;
  }
}
</style>